export const getTransactionHistoryData = state => state.transactionHistory;
